module.exports = __webpack_public_path__ + "img/facebook.f17ed2e0.svg";